/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type ApplyButtonPreScreeningLanguageFragment = {
  __typename?: 'ProfileLanguage';
  identifier?: string | null;
  text?: string | null;
  skillLevelId?: number | null;
};

export type ApplyButtonPreScreeningWorkEligibilityFragment = {
  __typename?: 'ProfileWorkEligibility';
  euWorkPermit?: boolean | null;
};

export type ApplyButtonPreScreeningProfileModulesFragment = {
  __typename?: 'ProfileModules';
  languagesModule?: {
    __typename?: 'ProfileLanguagesModule';
    content?: {
      __typename?: 'ProfileLanguages';
      collection?: Array<{
        __typename?: 'ProfileLanguage';
        identifier?: string | null;
        text?: string | null;
        skillLevelId?: number | null;
      } | null> | null;
    } | null;
  } | null;
  workEligibilityModule?: {
    __typename?: 'ProfileWorkEligibilityModule';
    content?: {
      __typename?: 'ProfileWorkEligibility';
      euWorkPermit?: boolean | null;
    } | null;
  } | null;
};

export type GetLanguagesAndWorkPermitQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
}>;

export type GetLanguagesAndWorkPermitQuery = {
  __typename?: 'Query';
  profileModules?: {
    __typename?: 'ProfileModules';
    languagesModule?: {
      __typename?: 'ProfileLanguagesModule';
      content?: {
        __typename?: 'ProfileLanguages';
        collection?: Array<{
          __typename?: 'ProfileLanguage';
          identifier?: string | null;
          text?: string | null;
          skillLevelId?: number | null;
        } | null> | null;
      } | null;
    } | null;
    workEligibilityModule?: {
      __typename?: 'ProfileWorkEligibilityModule';
      content?: {
        __typename?: 'ProfileWorkEligibility';
        euWorkPermit?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export const ApplyButtonPreScreeningLanguageFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplyButtonPreScreeningLanguage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProfileLanguage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'skillLevelId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApplyButtonPreScreeningLanguageFragment, unknown>;
export const ApplyButtonPreScreeningWorkEligibilityFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplyButtonPreScreeningWorkEligibility' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProfileWorkEligibility' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'euWorkPermit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplyButtonPreScreeningWorkEligibilityFragment,
  unknown
>;
export const ApplyButtonPreScreeningProfileModulesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplyButtonPreScreeningProfileModules' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProfileModules' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languagesModule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ApplyButtonPreScreeningLanguage',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workEligibilityModule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ApplyButtonPreScreeningWorkEligibility',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplyButtonPreScreeningLanguage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProfileLanguage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'skillLevelId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplyButtonPreScreeningWorkEligibility' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProfileWorkEligibility' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'euWorkPermit' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApplyButtonPreScreeningProfileModulesFragment,
  unknown
>;
export const GetLanguagesAndWorkPermitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getLanguagesAndWorkPermit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SlugOrID' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'profileModules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeDeactivatedModules' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'ApplyButtonPreScreeningProfileModules',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplyButtonPreScreeningLanguage' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProfileLanguage' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'identifier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'skillLevelId' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplyButtonPreScreeningWorkEligibility' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProfileWorkEligibility' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'euWorkPermit' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplyButtonPreScreeningProfileModules' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ProfileModules' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'languagesModule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collection' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'ApplyButtonPreScreeningLanguage',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'workEligibilityModule' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'ApplyButtonPreScreeningWorkEligibility',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLanguagesAndWorkPermitQuery,
  GetLanguagesAndWorkPermitQueryVariables
>;
